// The translations, one file per area of the app and language. es/ is Mexico
// and the rest of Latin America; es-ES/ only holds Spain's differences; pt/ is
// Brazil; pt-PT/ only holds Portugal's differences. Generated by npm run
// i18n:check -- --write-catalog; the check fails if it's out of date.

import esApp from "./es/app.json";
import esCommon from "./es/common.json";
import esDonations from "./es/donations.json";
import esEvents from "./es/events.json";
import esGolive from "./es/golive.json";
import esGuests from "./es/guests.json";
import esLibrary from "./es/library.json";
import esOnboarding from "./es/onboarding.json";
import esPaywall from "./es/paywall.json";
import esProfile from "./es/profile.json";
import esRooms from "./es/rooms.json";
import esSettings from "./es/settings.json";
import esSupport from "./es/support.json";
import esTeams from "./es/teams.json";
import esTickets from "./es/tickets.json";
import esVideo from "./es/video.json";
import esWhatsnew from "./es/whatsnew.json";

import esESApp from "./es-ES/app.json";
import esESCommon from "./es-ES/common.json";
import esESDonations from "./es-ES/donations.json";
import esESEvents from "./es-ES/events.json";
import esESGolive from "./es-ES/golive.json";
import esESGuests from "./es-ES/guests.json";
import esESLibrary from "./es-ES/library.json";
import esESOnboarding from "./es-ES/onboarding.json";
import esESPaywall from "./es-ES/paywall.json";
import esESProfile from "./es-ES/profile.json";
import esESRooms from "./es-ES/rooms.json";
import esESSettings from "./es-ES/settings.json";
import esESSupport from "./es-ES/support.json";
import esESTeams from "./es-ES/teams.json";
import esESTickets from "./es-ES/tickets.json";
import esESVideo from "./es-ES/video.json";
import esESWhatsnew from "./es-ES/whatsnew.json";

import deApp from "./de/app.json";
import deCommon from "./de/common.json";
import deDonations from "./de/donations.json";
import deEvents from "./de/events.json";
import deGolive from "./de/golive.json";
import deGuests from "./de/guests.json";
import deLibrary from "./de/library.json";
import deOnboarding from "./de/onboarding.json";
import dePaywall from "./de/paywall.json";
import deProfile from "./de/profile.json";
import deRooms from "./de/rooms.json";
import deSettings from "./de/settings.json";
import deSupport from "./de/support.json";
import deTeams from "./de/teams.json";
import deTickets from "./de/tickets.json";
import deVideo from "./de/video.json";
import deWhatsnew from "./de/whatsnew.json";

import frApp from "./fr/app.json";
import frCommon from "./fr/common.json";
import frDonations from "./fr/donations.json";
import frEvents from "./fr/events.json";
import frGolive from "./fr/golive.json";
import frGuests from "./fr/guests.json";
import frLibrary from "./fr/library.json";
import frOnboarding from "./fr/onboarding.json";
import frPaywall from "./fr/paywall.json";
import frProfile from "./fr/profile.json";
import frRooms from "./fr/rooms.json";
import frSettings from "./fr/settings.json";
import frSupport from "./fr/support.json";
import frTeams from "./fr/teams.json";
import frTickets from "./fr/tickets.json";
import frVideo from "./fr/video.json";
import frWhatsnew from "./fr/whatsnew.json";

import nlApp from "./nl/app.json";
import nlCommon from "./nl/common.json";
import nlDonations from "./nl/donations.json";
import nlEvents from "./nl/events.json";
import nlGolive from "./nl/golive.json";
import nlGuests from "./nl/guests.json";
import nlLibrary from "./nl/library.json";
import nlOnboarding from "./nl/onboarding.json";
import nlPaywall from "./nl/paywall.json";
import nlProfile from "./nl/profile.json";
import nlRooms from "./nl/rooms.json";
import nlSettings from "./nl/settings.json";
import nlSupport from "./nl/support.json";
import nlTeams from "./nl/teams.json";
import nlTickets from "./nl/tickets.json";
import nlVideo from "./nl/video.json";
import nlWhatsnew from "./nl/whatsnew.json";

import plApp from "./pl/app.json";
import plCommon from "./pl/common.json";
import plDonations from "./pl/donations.json";
import plEvents from "./pl/events.json";
import plGolive from "./pl/golive.json";
import plGuests from "./pl/guests.json";
import plLibrary from "./pl/library.json";
import plOnboarding from "./pl/onboarding.json";
import plPaywall from "./pl/paywall.json";
import plProfile from "./pl/profile.json";
import plRooms from "./pl/rooms.json";
import plSettings from "./pl/settings.json";
import plSupport from "./pl/support.json";
import plTeams from "./pl/teams.json";
import plTickets from "./pl/tickets.json";
import plVideo from "./pl/video.json";
import plWhatsnew from "./pl/whatsnew.json";

import ptApp from "./pt/app.json";
import ptCommon from "./pt/common.json";
import ptDonations from "./pt/donations.json";
import ptEvents from "./pt/events.json";
import ptGolive from "./pt/golive.json";
import ptGuests from "./pt/guests.json";
import ptLibrary from "./pt/library.json";
import ptOnboarding from "./pt/onboarding.json";
import ptPaywall from "./pt/paywall.json";
import ptProfile from "./pt/profile.json";
import ptRooms from "./pt/rooms.json";
import ptSettings from "./pt/settings.json";
import ptSupport from "./pt/support.json";
import ptTeams from "./pt/teams.json";
import ptTickets from "./pt/tickets.json";
import ptVideo from "./pt/video.json";
import ptWhatsnew from "./pt/whatsnew.json";

import ptPTApp from "./pt-PT/app.json";
import ptPTCommon from "./pt-PT/common.json";
import ptPTDonations from "./pt-PT/donations.json";
import ptPTEvents from "./pt-PT/events.json";
import ptPTGolive from "./pt-PT/golive.json";
import ptPTGuests from "./pt-PT/guests.json";
import ptPTLibrary from "./pt-PT/library.json";
import ptPTOnboarding from "./pt-PT/onboarding.json";
import ptPTPaywall from "./pt-PT/paywall.json";
import ptPTProfile from "./pt-PT/profile.json";
import ptPTRooms from "./pt-PT/rooms.json";
import ptPTSettings from "./pt-PT/settings.json";
import ptPTSupport from "./pt-PT/support.json";
import ptPTTeams from "./pt-PT/teams.json";
import ptPTTickets from "./pt-PT/tickets.json";
import ptPTVideo from "./pt-PT/video.json";
import ptPTWhatsnew from "./pt-PT/whatsnew.json";

import jaApp from "./ja/app.json";
import jaCommon from "./ja/common.json";
import jaDonations from "./ja/donations.json";
import jaEvents from "./ja/events.json";
import jaGolive from "./ja/golive.json";
import jaGuests from "./ja/guests.json";
import jaLibrary from "./ja/library.json";
import jaOnboarding from "./ja/onboarding.json";
import jaPaywall from "./ja/paywall.json";
import jaProfile from "./ja/profile.json";
import jaRooms from "./ja/rooms.json";
import jaSettings from "./ja/settings.json";
import jaSupport from "./ja/support.json";
import jaTeams from "./ja/teams.json";
import jaTickets from "./ja/tickets.json";
import jaVideo from "./ja/video.json";
import jaWhatsnew from "./ja/whatsnew.json";

export const es = Object.assign(
  {},
  esApp,
  esCommon,
  esDonations,
  esEvents,
  esGolive,
  esGuests,
  esLibrary,
  esOnboarding,
  esPaywall,
  esProfile,
  esRooms,
  esSettings,
  esSupport,
  esTeams,
  esTickets,
  esVideo,
  esWhatsnew
);

export const esES = Object.assign(
  {},
  esESApp,
  esESCommon,
  esESDonations,
  esESEvents,
  esESGolive,
  esESGuests,
  esESLibrary,
  esESOnboarding,
  esESPaywall,
  esESProfile,
  esESRooms,
  esESSettings,
  esESSupport,
  esESTeams,
  esESTickets,
  esESVideo,
  esESWhatsnew
);

export const de = Object.assign(
  {},
  deApp,
  deCommon,
  deDonations,
  deEvents,
  deGolive,
  deGuests,
  deLibrary,
  deOnboarding,
  dePaywall,
  deProfile,
  deRooms,
  deSettings,
  deSupport,
  deTeams,
  deTickets,
  deVideo,
  deWhatsnew
);

export const fr = Object.assign(
  {},
  frApp,
  frCommon,
  frDonations,
  frEvents,
  frGolive,
  frGuests,
  frLibrary,
  frOnboarding,
  frPaywall,
  frProfile,
  frRooms,
  frSettings,
  frSupport,
  frTeams,
  frTickets,
  frVideo,
  frWhatsnew
);

export const nl = Object.assign(
  {},
  nlApp,
  nlCommon,
  nlDonations,
  nlEvents,
  nlGolive,
  nlGuests,
  nlLibrary,
  nlOnboarding,
  nlPaywall,
  nlProfile,
  nlRooms,
  nlSettings,
  nlSupport,
  nlTeams,
  nlTickets,
  nlVideo,
  nlWhatsnew
);

export const pl = Object.assign(
  {},
  plApp,
  plCommon,
  plDonations,
  plEvents,
  plGolive,
  plGuests,
  plLibrary,
  plOnboarding,
  plPaywall,
  plProfile,
  plRooms,
  plSettings,
  plSupport,
  plTeams,
  plTickets,
  plVideo,
  plWhatsnew
);

export const pt = Object.assign(
  {},
  ptApp,
  ptCommon,
  ptDonations,
  ptEvents,
  ptGolive,
  ptGuests,
  ptLibrary,
  ptOnboarding,
  ptPaywall,
  ptProfile,
  ptRooms,
  ptSettings,
  ptSupport,
  ptTeams,
  ptTickets,
  ptVideo,
  ptWhatsnew
);

export const ptPT = Object.assign(
  {},
  ptPTApp,
  ptPTCommon,
  ptPTDonations,
  ptPTEvents,
  ptPTGolive,
  ptPTGuests,
  ptPTLibrary,
  ptPTOnboarding,
  ptPTPaywall,
  ptPTProfile,
  ptPTRooms,
  ptPTSettings,
  ptPTSupport,
  ptPTTeams,
  ptPTTickets,
  ptPTVideo,
  ptPTWhatsnew
);

export const ja = Object.assign(
  {},
  jaApp,
  jaCommon,
  jaDonations,
  jaEvents,
  jaGolive,
  jaGuests,
  jaLibrary,
  jaOnboarding,
  jaPaywall,
  jaProfile,
  jaRooms,
  jaSettings,
  jaSupport,
  jaTeams,
  jaTickets,
  jaVideo,
  jaWhatsnew
);
